'use client'

import React from 'react';

interface VideoSchemaProps {
  videoAltText: string;
  desktopThumbnailUrl?: string;
  mobileThumbnailUrl?: string;
  videoUrl?: string;
}

const VideoSchema: React.FC<VideoSchemaProps> = ({
  videoAltText,
  desktopThumbnailUrl,
  mobileThumbnailUrl,
  videoUrl
}) => {
  // Don't render schema if videoUrl is not provided (required by Schema.org)
  if (!videoUrl) {
    return null;
  }

  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  const thumbnailUrl = isMobile ? mobileThumbnailUrl : desktopThumbnailUrl;
  
  // Build schema object with required fields
  const videoSchema: any = {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    name: videoAltText,
    description: videoAltText,
    uploadDate: new Date().toISOString(),
    contentUrl: videoUrl,
  };

  // Only include thumbnailUrl if it exists
  if (thumbnailUrl) {
    videoSchema.thumbnailUrl = [thumbnailUrl];
  }

  return (
    <script 
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(videoSchema) }}
    />
  );
};

export default VideoSchema;
